module.exports = __webpack_public_path__ + "static/media/design_principles@x2.f88f094d.png";


//////////////////
// WEBPACK FOOTER
// ./src/projects/mood/src/design_principles@x2.png
// module id = 527
// module chunks = 0